// extracted by mini-css-extract-plugin
module.exports = {"content":"PageContentError-content-Qr1YP PageContent-content-38ErY"};